/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const jingleCollectionItemModelSchema = z.object({
    "id": z.string().uuid().describe("Идентификатор"),
"name": z.string().describe("Название"),
"number": z.number().int().describe("Порядковый номер")
    })